import type { FormState } from "../../../shared/types/workflow/workflow-form.types";
import { useWorkflowTransition } from "../hooks/use-workflow-transition";
import { useWorkflowFormContext } from "./workflow-form-context";
import { WorkflowTransitionButton } from "./workflow-transition-button";
import { WorkflowTransitionDialog } from "./workflow-transition-dialog";

export interface WorkflowTransitionProps {
  /**
   * Called when the transition is submitted.
   * @param formData - The form data to submit (object or null)
   */
  onSubmit: (formData: FormState | null) => Promise<void>;
  initialValues?: Partial<FormState>;
  closeImmediately?: boolean;
  disabled?: boolean;
}

/**
 * Orchestrator component that combines WorkflowTransitionButton and WorkflowTransitionDialog.
 *
 * This component handles two scenarios:
 * 1. If transition has a dialog action: shows button that opens dialog
 * 2. If transition has no action (empty object): shows button that executes immediately
 */
export function WorkflowTransition(props: WorkflowTransitionProps) {
  const {
    isOpen,
    schema,
    hasDialogAction,
    handleButtonClick,
    handleFormSubmit,
    handleOpenChange,
  } = useWorkflowTransition(props);

  const formContext = useWorkflowFormContext();
  if (!schema?.trigger) {
    return null;
  }

  return (
    <>
      <WorkflowTransitionButton
        trigger={schema.trigger}
        onClick={handleButtonClick}
        loading={formContext?.isSubmitting}
        disabled={props.disabled}
      />
      {hasDialogAction && (
        <WorkflowTransitionDialog
          open={isOpen}
          onOpenChange={handleOpenChange}
          onFormSubmit={handleFormSubmit}
        />
      )}
    </>
  );
}
